import DangerError from './errorTypes/DangerError/DangerError';
import React from 'react';
import InfoError from './errorTypes/InfoError/InfoError';

export enum ErrorStepKey {
  MissingColumnHeaders = 'MissingColumnHeaders',
  MissingRequiredHeaders = 'MissingRequiredHeaders',
  RowsWithoutSameColumns = 'RowsWithoutSameColumns',
  EmptyHeaders = 'EmptyHeaders',
  RepeatedHeaders = 'RepeatedHeaders',
}

export type StepComponent = {
  header?: JSX.Element;
  body: JSX.Element;
};

export type ErrorStepComponentProps = {
  title?: string;
  description: string;
};

export type ErrorStepContent = ErrorStepComponentProps & {
  type: 'info' | 'danger';
};

const errorStepContent: Record<ErrorStepKey, ErrorStepContent> = {
  [ErrorStepKey.MissingColumnHeaders]: {
    title: 'Missing Column Headers!',
    description:
      'Your file does not contain column headers. ' +
      'Please add a row of headers in your document and re-import.',
    type: 'info',
  },
  [ErrorStepKey.MissingRequiredHeaders]: {
    title: 'Missing Column Headers!',
    description:
      'Your file does not contain column headers. ' +
      'Please add a row of headers in your document that correspond to the ' +
      '*required Field names below and re-import your document.',
    type: 'danger',
  },
  [ErrorStepKey.RowsWithoutSameColumns]: {
    description:
      'Your file must have the same number of columns for every row. Please correct the file and re-import.',
    type: 'info',
  },
  [ErrorStepKey.EmptyHeaders]: {
    description:
      'The first row of your file must have valid headers. Please correct the file and re-import.',
    type: 'info',
  },
  [ErrorStepKey.RepeatedHeaders]: {
    description:
      "Each column name in your file's header must be different. Please correct the file and re-import.",
    type: 'info',
  },
};

interface ErrorStepProps {
  errorKey: ErrorStepKey;
}

const ErrorStep = ({ errorKey }: ErrorStepProps): StepComponent => {
  const { type, ...props } = errorStepContent[errorKey];

  if (type === 'info') {
    return InfoError({ ...props });
  }

  if (type === 'danger') {
    return DangerError({ ...props });
  }

  return {
    body: <></>,
  };
};

export default ErrorStep;
